const secretHashKey = `-----BEGIN RSA PRIVATE KEY-----
MIIEogIBAAKCAQEA523w2fmzAiun2+rMQ4N69wxSDq4uv7Nb+5LPuXLsdUFkLCGl
uIJLV7zg7uzVdG7dwsNJr99Iq0AudzN/xf7hQLJGhMjQC4KxoNd2IUc6C92b04/O
C5efmewyh/h47uBsRfNc1aXb5VCzFDBjdpZOc8/1SmnJP/Pc9fmyna590v7Hp9cK
QDvQSPQtCTlJmXymAoWa0acKM2gyxKTbhw1eW7x0GwYyLX7tiGk9xHTNuyruCTrr
1E2T6vZevTm4B2g8c0z3ejwiznESsBjNH4CFOmQpjxJDfxFeMEOf0Rh/2TDXhBxz
Si9Ji5WeqmzkXAEQzQesyyMtlIdPbn88cirLpQIDAQABAoIBAGcvGYfWUP3SwRDI
azJe2OB1WdC50JYgPg64sm0Y1FyjPyp+Bglx7m28BP4CElnLZIyFzcDgaOIRx6XW
DE4XCg9ybQafEkNPjisMZdsIitTnhaaaI1//xmU2boE5Q5Id9ahqjSWkwZpIlM+X
k4E4GtqACfmXmOcur4HsRrsPJYKAxQhS2xSbEiPUvQMvXlWIUGFu647LXFtpInGW
dAJMOAXm4YGiIZFzlbWz1U9yfr9tDUmS4KC4ubEkgiDOXniNyBGM63u4ECUWiDlw
gARWT4Vy4MpXyCqBYj7BWFv0p0NLbUvgvlsMaKa34NB7BQ3VEI2AbseG1UrKUm4+
qvpI/jECgYEA/LDsIp/MKS1SJm1jtMpMY2Uuh76WMRyn+KLCprIfP8xh0U24SU3E
rLn6WtFBxjW8S9aqMq4E8eM61Y1OZI3jetAi/N4MptJnwsh8B4ljy2qBk/ydqjWq
OzDL8Y0q58Zv2/wKVd6B1usRwDYvrVTAI3uM/fEDlP2s51OMLmgFh9MCgYEA6nW+
nSB4SOIHk827/EmuTGlpCyyoY0ex6aV3wyQPAX1Q1CPeDf1ddnK+RVx5hQij9w1h
tZQZ7rnqHcyiQ7/H03sZdsRir31lrYs6kHyUVXtWNiKfnIacrZkAQcGWucBgLzpt
6XOSyBK4cJYg66za9jJ0ywc2KFPZ+bXNKTnOa6cCgYAPCoTzxqlDZjQ2n1pI/6Wu
YO51HA4anEcPULjfbUjY5lSIPeUTT/K+CU/yqfQNVVOA/CUjYSJgN5Nf9MpOx/db
bxo2DQ2ZvHp6qK5hUHdFO3C9G1NTN2CLp2rsVOfR5gjwgj8nP1hhL5rd4xvRaHML
aaZJ01fQPY1WM63rcTurCwKBgGnvF1fRMufjUH8kpro/5EPcIL0OyWpKG4Ww4KLH
6QvIPjwLlKoHfzIkd/nI5ZMJK2RVpH8xUmI9mB0st2ga/8N6zC+QXfJimw1Fagmc
cD0LRBGjpTBI1gPNrIMJX/u/gvXz1XN0Z66EXtdnzaoOaMRyWbjeIkcoU8Vysibd
WnnjAoGAMtDeCHhqUX3M0vKb2KORqj7keWzNqjRe1NFMhhqvSat/vpF6Gev+awlV
4zN4mb+dKsW6T3CLQB5XMTHMu+1GsVD/yr/Yvm/cucVWcbc3xj2WiAWNAzn7TZgG
ybOToFxH+vl8hCgB+YNSGNuXUCoLT8J8bFrF+OPwp+qmNr6KsUo=
-----END RSA PRIVATE KEY-----`;
export default secretHashKey;
